import { TooltipDirective } from '../../../../auxiliares/tooltip/tooltip.directive';
import { BOTONES } from '../../../../componentes/botones';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

export interface HelpItem {
  term: string;
  desc: string;
}

/**
 * Botón de ayuda contextual. Se coloca en la cabecera de una `app-content-card`
 * (slot `card-header-actions`) y despliega un panel que explica qué significan
 * las métricas / variables de esa sección del dashboard.
 */
@Component({
  selector: 'app-metrica-help',
  standalone: true,
  imports: [TooltipDirective, 
    CommonModule,
    BOTONES,
    MatIconModule,
    MatMenuModule,
    
  ],
  encapsulation: ViewEncapsulation.None,
  template: `
    <button
      irxBotonIcono
      [matMenuTriggerFor]="menu"
      tooltip="¿Qué significa esta sección?"
      (click)="$event.stopPropagation()"
    >
      <mat-icon>help_outline</mat-icon>
    </button>

    <mat-menu #menu="matMenu" class="metrica-help-menu" xPosition="before">
      <div class="metrica-help-panel" (click)="$event.stopPropagation()">
        @if (intro) {
          <p class="metrica-help-intro">{{ intro }}</p>
        }
        @for (item of items; track item.term) {
          <div class="metrica-help-item">
            <span class="metrica-help-term">{{ item.term }}</span>
            <span class="metrica-help-desc">{{ item.desc }}</span>
          </div>
        }
      </div>
    </mat-menu>
  `,
  styles: [
    `
      .metrica-help-menu .mat-mdc-menu-content {
        padding: 0 !important;
      }
      .metrica-help-panel {
        max-width: 360px;
        padding: 14px 16px 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        cursor: default;
      }
      .metrica-help-intro {
        margin: 0 0 2px;
        font-size: 0.84rem;
        line-height: 1.45;
        opacity: 0.85;
      }
      .metrica-help-item {
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding-bottom: 9px;
        border-bottom: 1px solid rgba(128, 128, 128, 0.12);
      }
      .metrica-help-item:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }
      .metrica-help-term {
        font-size: 0.78rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        color: var(--theme-primary-500, #3f51b5);
      }
      .dark-theme .metrica-help-term {
        color: var(--theme-primary-200, #9fa8da);
      }
      .metrica-help-desc {
        font-size: 0.79rem;
        line-height: 1.4;
        opacity: 0.72;
      }
    `,
  ],
})
export class MetricaHelpComponent {
  /** Texto introductorio opcional que resume la sección. */
  @Input() intro = '';

  /** Lista de términos/variables con su explicación. */
  @Input() items: HelpItem[] = [];
}
